import { z } from "zod";
import { StoreIdSchema } from "@/actions/schemas/stores";

type Category = z.infer<typeof CategorySchema>;

type GetCategoryListInput = z.infer<typeof GetCategoryListInputSchema>;

type GetCategoryListOutput = z.infer<typeof GetCategoryListOutputSchema>;

const CategorySchema = z.object({
  id: z.string(),
  name: z.string(),
});

const GetCategoryListInputSchema = z.object({
  storeId: StoreIdSchema,
});

const GetCategoryListOutputSchema = z.object({
  items: z
    .array(CategorySchema)
    .nullable()
    .transform((value) => value ?? []),
});

export {
  CategorySchema,
  GetCategoryListInputSchema,
  GetCategoryListOutputSchema,
  type Category,
  type GetCategoryListInput,
  type GetCategoryListOutput,
};
